import {
    FETCH_RESET_CONTENT,
    FETCH_RESET_CONTENT_SUCCESS,
    FETCH_RESET_CONTENT_FAILED,
    RESET_MESSAGE,
    RESET_MESSAGE_SUCCESS,
    RESET_MESSAGE_FAILED,
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
};

export default function (state = initialState, { type, payload }) {
    switch (type) {
        case FETCH_RESET_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_RESET_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_RESET_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case RESET_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case RESET_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case RESET_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };

        default:
            return state;
    }
}
